<template>
    <v-progress-linear
        indeterminate
        color="grey"
        class="ma-0"
    ></v-progress-linear>        
</template>

<script>
export default {   
}
</script>

<style>

</style>
